import React from 'react'
import { withRouter } from 'react-router'
import { default as i18n, lang, TitleDescription } from '../utils/i18n'
import '../layouts/subpage.scss'
import { sessionizeUrl } from '../utils/const'
import Link from '../utils/link'

export default withRouter(function Requirements ({ location, data }) {
  const ln = lang(location)
  return (
    <div lang={ln}>
      <TitleDescription texts={{
        en: { title: 'Call for Papers', desc: 'DroidKaigi2018 is currently accepting speaker applications.' },
        ja: { title: '募集要項', desc: 'DroidKaigi 2018での発表者を募集しています。' }
      }} />
      <div className='subpage-title-wrapper bg-gray2'>
        <h2 className='text-yellow1'><Text id='title' /></h2>
      </div>
      <div className='subpage-container'>
        <h2><Text id='finished' /></h2>
        <div className='subpage-container-disabled'>
          <Text id='body' />
        </div>
        <div style={{ marginTop: '40px' }}>
          <Link to='/proposals/' className='subpage-button-black'><Text id='checkSubmits' /></Link>
          <a className='subpage-button-green-disabled'><Text id='submitTalk' /></a>
        </div>
      </div>
    </div>
  )
})

function pastRequirements () {
  return <span>
    <a className='subpage-link' href='https://docs.google.com/spreadsheets/d/186-gpTHPvGwtQTFqvuSs10Tz3ca49gKNZ7uoRSi2HnE/edit#gid=0'>
      2015
    </a>
    &nbsp;
    <a className='subpage-link' href='https://docs.google.com/spreadsheets/d/1XEkt0MWC_vBI2BHBH0qwHxM7QdqajP3zu1lDnCytJoU/edit#gid=0'>
      2016
    </a>
    &nbsp;
    <a className='subpage-link' href='https://docs.google.com/spreadsheets/d/1k4bpUjpAyiJfTCJCFc9y48FYQAujZfCA_fxsmN2M4LI/edit#gid=0'>
      2017
    </a>
  </span>
}

const Text = i18n({
  en: {
    title: `Call for Papers`,
    checkSubmits: 'Check Talk Stats',
    submitTalk: 'Submit Talk!',
    finished: 'Call for Speakers is closed. Thank you for your applications!',
    body: <div>
      <h2>About DroidKaigi</h2>
      <p>DroidKaigi is a conference tailored for developers organized by developers. Its main focus is to provide
        developers a place to network and share knowledge with their peers.<br />
        DroidKaigi 2017 saw over 800 developers with 76 sessions.</p>
      <h2>Call for Papers</h2>
      <p>DroidKaigi2018 is currently accepting speaker applications. Please choose a topic from the list below and fill
        out the form with your talk’s title and abstract. For better session selection, topics have been further
        segmented this year.</p>
      <h2>Topics</h2>
      <h3>UI and Design</h3>
      <ul>
        <li>Material Design</li>
        <li>Drawables</li>
        <li>Animations etc.</li>
      </ul>
      <h3>Designing App Architecture</h3>
      <ul>
        <li>Clean Architecture</li>
        <li>Android Architecture Components</li>
        <li>MVVM, MVC, MVP</li>
        <li>DI etc.</li>
      </ul>
      <h3>Development Process and Methodology</h3>
      <ul>
        <li>Growth Hacks</li>
        <li>Release Management</li>
        <li>Android/iOS Parallel Development etc.</li>
      </ul>
      <h3>Team Building and Development Conventions</h3>
      <ul>
        <li>Team Development/Team Building</li>
        <li>Code Review etc.</li>
      </ul>
      <h3>CI</h3>
      <ul>
        <li>CircleCI, Jenkins, TravisCI, Bitrise</li>
        <li>OpenSTF, FirebaseTestLab etc.</li>
      </ul>
      <h3>Hardware and IoT</h3>
      <ul>
        <li>Cameras, Sensors</li>
        <li>Video, Images, and Audio Technology</li>
        <li>Arduino, Drones etc.</li>
      </ul>
      <h3>Quality and Sustainability</h3>
      <ul>
        <li>Operation</li>
        <li>Testing</li>
        <li>Backward Compatibility/Device Compatibility</li>
        <li>Security</li>
      </ul>
      <h3>Android O</h3>
      <ul>
        <li>Doze</li>
        <li>Notifications etc.</li>
      </ul>
      <h3>Android Framework and Support Library</h3>
      <ul>
        <li>Inside Android, Media, Protocol Stacks</li>
        <li>OS Version Differences etc.</li>
      </ul>
      <h3>OSS Development and Management</h3>
      <ul>
        <li>OSS Development and Management as an Individual</li>
        <li>Community-driven OSS Development and Management etc.</li>
      </ul>
      <h3>Hands-on Codelabs</h3>
      <ul>
        <li>Kotlin Hands-on Lab</li>
        <li>Hybrid Framework Hands-on Lab</li>
      </ul>
      <h3>Productivity and Tools</h3>
      <ul>
        <li>Android Studio</li>
        <li>Build Systems(Speed, Efficiency etc.)</li>
        <li>Firebase etc.</li>
      </ul>
      <h3>Platforms</h3>
      <ul>
        <li>TV, Watch, Home</li>
        <li>Auto etc.</li>
      </ul>
      <h3>Other</h3>
      <ul>
        <li>Anything that doesn't fit into the categories above</li>
      </ul>
      <h2>Submission Details</h2>
      <p>Submit the topic, title, and abstract (1,500 characters max) of your talk from <strike>here</strike>.
        You may edit yourapplication until the deadline with the account used for submission.<br />
        The title, abstract, name of speaker, and other details of applications will be published regardless of their
        result. The above topics are for selection purposes, and are subject to change in the final timetable.</p>
      <table>
        <tr>
          <th>Submission Deadline</th>
          <td>Oct 15, 2017 23:59 JST</td>
        </tr>
        <tr>
          <th>Result Announcement</th>
          <td>Early-November 2017</td>
        </tr>
        <tr>
          <th>Tickets</th>
          <td>
            If selected, you will not need a ticket for admission.<br />
            Those not selected may purchase tickets at a discount price even after they sell out.
          </td>
        </tr>
        <tr>
          <th>Submission Form</th>
          <td><strike>{sessionizeUrl}</strike></td>
        </tr>
      </table>
      <p>Applications are more likely to be accepted if they are:</p>
      <ul>
        <li>Android specific</li>
        <li>Involves an area of expertise (i.e. not about a subject widely known)</li>
        <li>Innovative (i.e. about a topic that demonstrates something thought to be impossible or very hard to
          achieve)
        </li>
      </ul>
      <p>Previous applications can be viewed here: {pastRequirements()}</p>
    </div>
  },

  ja: {
    title: `募集要項`,
    checkSubmits: '応募状況を見る',
    submitTalk: 'トークを投稿する！',
    finished: 'トーク応募は締め切りました。ご応募ありがとうございました。',
    body: <div>
      <h2>DroidKaigiとは</h2>
      <p>DroidKaigiは、Android技術情報の共有とコミュニケーションを目的に開催する、エンジニアが主役のAndroidカンファレンスです。<br />
        DroidKaigi 2017では、76本のセッションに800人以上の開発者が参加しました。</p>
      <h2>発表者の募集</h2>
      <p>DroidKaigi 2018での発表者を募集しています。
        次に挙げるトピックの中から1つを選択して、発表タイトルとアブストラクトを応募してください。よりよいセッションを採択できるようにするため、2017年よりもトピックが細分化されました。</p>
      <h2>トピック</h2>
      <h3>UI・デザイン (UI and Design)</h3>
      <ul>
        <li>マテリアルデザイン</li>
        <li>Drawablesの扱い</li>
        <li>アニメーション など</li>
      </ul>
      <h3>ソフトウェアアーキテクチャ (Designing App Architecture)</h3>
      <ul>
        <li>Clean Architecture</li>
        <li>Android Architecture Components</li>
        <li>MVVM, MVC, MVP etc.</li>
        <li>DI など</li>
      </ul>
      <h3>開発プロセス (Development Process and Methodology)</h3>
      <ul>
        <li>グロースハック</li>
        <li>リリースマネジメント</li>
        <li>Android/iOS同時開発 など</li>
      </ul>
      <h3>チームビルディング・開発規約 (Team Building and Development Conventions)</h3>
      <ul>
        <li>チーム開発・ビルディング</li>
        <li>コードレビュー など</li>
      </ul>
      <h3>CI (CI)</h3>
      <ul>
        <li>CircleCI, Jenkins, TravisCi, bitrise</li>
        <li>OpenSTF, FirebaseTestLab など</li>
      </ul>
      <h3>ハードウェア / IoT (Hardware and IoT)</h3>
      <ul>
        <li>カメラ, センサー</li>
        <li>動画、画像、音声技術</li>
        <li>Arduino, ドローン など</li>
      </ul>
      <h3>ソフトウェア保守・テスト (Quality and Sustainability)</h3>
      <ul>
        <li>運用</li>
        <li>テスト</li>
        <li>後方/機種間互換性</li>
        <li>セキュリティ</li>
      </ul>
      <h3>Android O (Android O)</h3>
      <ul>
        <li>Doze</li>
        <li>Notification など</li>
      </ul>
      <h3>Android FrameworkとSupport Library (Android Framework and Support Library)</h3>
      <ul>
        <li>Android内部の仕組み、Media、プロトコルスタック</li>
        <li>OSバージョンごとの実装 など</li>
      </ul>
      <h3>OSS開発・運営 (OSS Development and Management)</h3>
      <ul>
        <li>個人でのOSS開発と運営</li>
        <li>コミュニティによるOSS開発と運営 など</li>
      </ul>
      <h3>ハンズオン・コードラボ (Hands-on Codelabs)</h3>
      <ul>
        <li>Kotlin ハンズオン</li>
        <li>ハイブリッドフレームワークハンズオン</li>
      </ul>
      <h3>開発環境 (Productivity and Tools)</h3>
      <ul>
        <li>Android Studio</li>
        <li>ビルドシステム（高速化、効率化等）</li>
        <li>Firebase など</li>
      </ul>
      <h3>マルチプラットフォーム (Platforms)</h3>
      <ul>
        <li>TV, Watch, Home</li>
        <li>Auto など</li>
      </ul>
      <h3>その他 (Other)</h3>
      <ul>
        <li>上記トピックに入らないもの</li>
      </ul>
      <h2>要項</h2>
      <p>応募先 <strike>{sessionizeUrl}</strike> のフォームより発表のトピック、タイトルとアブストラクト(最大1,500文字)等を送信してください。
        送信時に登録したアカウントを利用することで応募締め切りまでの間、自由に編集することが可能です。<br />
        応募いただいたタイトルやセッション用氏名等は採択、非採択にかかわらず応募状況にて公開されます。また選択したトピックは審査上のものであり、タイムテーブル発表時の表記と異なる場合があります。<br />
        あらかじめご了承ください。</p>
      <table>
        <tr>
          <th>応募期限</th>
          <td>2017/10/15 23:59</td>
        </tr>
        <tr>
          <th>結果発表予定日</th>
          <td>2017年11月初旬</td>
        </tr>
        <tr>
          <th>チケット</th>
          <td>
            採択時はチケット購入無しで参加が可能です。<br />
            不採択の場合、チケット完売時であっても割引価格で購入が可能となります。
          </td>
        </tr>
        <tr>
          <th>応募先</th>
          <td><strike>{sessionizeUrl}</strike></td>
        </tr>
      </table>
      <p>応募に当たって以下の3点を満たしていると採択されやすくなります。</p>
      <ul>
        <li>Android specific: Android 固有であること</li>
        <li>Expertise: よく知られている情報ではなく、専門性があること</li>
        <li>Innovation: いままでに可能でなかったことを可能にしていること、革新性があること</li>
      </ul>
      <p>参考資料(過去の応募一覧): {pastRequirements()}</p>
    </div>
  }
})



// WEBPACK FOOTER //
// ./src/pages/requirements.js